module.exports = __webpack_public_path__ + "chrome-logo.91e9d46453012bf9ab4831cf13d79b38.png";